var angular = require("angular");
var _ = require("underscore");

require("../contentUpload");

 angular
  .module("app.directives")
  .directive("contentField", function($timeout) {
    return {
      restrict: "E",
      require: "?ngModel",
      scope: {
        selectLabel: "@",
        changeLabel: "@",
        alwaysShowFileName: "@",
        allowDelete: "@",
        filter: "@",
      },
      template: require("./template.pug"),
      link: function(scope, element, attrs, ngModel) {
        if (!ngModel) throw "ngModel required";
        scope.selectLabel = scope.selectLabel || "Select document...";
        scope.changeLabel = scope.changeLabel || "Change document...";

        scope.required = attrs.hasOwnProperty("required");
        scope.publicUpload = attrs.hasOwnProperty("publicUpload");

        function updateUrls() {
          var obj = ngModel.$viewValue;
          scope.obj = obj;
          if (obj && obj.fileName) {
            scope.initial_filename = obj.fileName;
          } else {
            scope.initial_filename = null;
          }
        }

        scope.upload.onDone = function(id, fileName, fileSize) {
          ngModel.$setViewValue({ id: id, fileName: fileName, fileSize: fileSize });
          updateUrls();
          scope.upload.reset();
        };

        scope.$watch('upload.busy', function(val){
          ngModel.$setValidity('uploading', !val);
        })

        if (scope.required) {
          scope.$watch(function(){
            return ngModel.$viewValue
          }, function(val){
            var isSet = val && val.fileName && (val.id || val.blobId);
            ngModel.$setValidity('required2', isSet);
          })
        }

        ngModel.$render = updateUrls;
      },
      controller: function($scope) {
        $scope.upload = {};
      }
    };
  });
